import { put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { setPerformedByOptions, setSelectedCrewMembers, setVitalsAssessedByOptions } from '../store/options.actions'
import { PCRConstants } from '../../pcr/store/pcr.constants'
import { getCrewListSelector } from '../../crew/selectors'
import { ICrewMember, ICrewMemberList } from '../../crew/store/crew.types'
import { sort } from '../../../utilities'

export function* getSelectedCrewMembers() {
  try {
    const crewList: ICrewMemberList = yield select(getCrewListSelector)
    const options = crewList.map((crewMember: ICrewMember) => {
      return { id: crewMember.userId!.id, name: crewMember.userId!.name }
    })

    sort(options)
    yield put(setPerformedByOptions(options))
    yield put(setSelectedCrewMembers(options))
    yield put(setVitalsAssessedByOptions(options))
  } catch (e) {
    yield put(throwPcrException(`getSelectedCrewMembers() error: ${e}`))
  }
}

export function* getSelectedCrewMembersSaga() {
  yield takeLatest([PCRConstants.CREATE_PCR], getSelectedCrewMembers)
}
